export class MyGreiffMap{
    $el = null;
    container_id = null;
    center_latitude=null
    center_longitude=null
    zoom=null
    map = null;
    markersByKey = {};
    default_color = '#b10023'
    stop_colors = {
        100: '#0d98ba',
        200:'#228B22',
        400:'#DFC375',
        300:'#937745'
    }
    typeIcons = {
        400: `<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="#B0995B" stroke="none">
            <path d="M1854 4672 c-47 -37 -56 -97 -29 -187 46 -149 58 -398 30 -612 -9
            -65 -34 -206 -56 -313 -102 -494 -117 -588 -125 -788 -7 -149 9 -297 46 -426
            27 -95 58 -138 121 -170 l53 -26 723 0 c794 0 766 -2 798 60 18 34 19 71 5
            120 -84 284 -73 528 50 1115 71 334 92 489 91 680 0 168 -14 278 -51 398 -24
            76 -56 120 -111 147 -37 19 -63 20 -781 20 -689 0 -745 -2 -764 -18z m1521
            -115 c26 -26 37 -51 56 -127 21 -84 23 -119 24 -305 0 -237 -6 -285 -85 -661
            -66 -313 -88 -440 -101 -605 -9 -101 -16 -139 -25 -139 -7 0 -47 -18 -89 -40
            -44 -23 -90 -40 -109 -40 -20 0 -74 21 -137 53 -98 49 -108 52 -179 52 -69 0
            -83 -4 -174 -47 -120 -59 -149 -60 -318 -17 -148 38 -188 36 -306 -21 -46 -22
            -99 -40 -117 -40 -32 0 -34 2 -40 43 -8 57 10 280 35 424 11 65 42 224 69 353
            28 129 59 300 71 380 36 248 27 516 -25 686 -28 94 -108 84 701 84 l716 0 33
            -33z m-498 -1963 c144 -72 189 -75 293 -20 38 20 76 36 83 36 10 0 16 -21 21
            -72 4 -40 18 -118 32 -172 13 -55 21 -103 16 -108 -5 -5 -328 -7 -719 -6
            l-711 3 -26 24 c-27 26 -59 112 -71 192 l-6 44 42 2 c26 2 79 20 132 45 106
            50 140 52 282 12 61 -16 126 -27 165 -28 59 0 77 5 175 52 67 32 124 52 145
            52 23 0 75 -20 147 -56z"/>
            <path d="M2346 4204 c-20 -19 -20 -17 0 -101 27 -113 15 -297 -35 -533 -50
            -244 -65 -363 -57 -465 14 -173 49 -245 104 -216 28 15 34 37 22 81 -37 139
            -30 275 29 572 47 232 65 380 56 463 -9 81 -33 186 -46 202 -15 18 -54 16 -73
            -3z"/>
            <path d="M2926 4198 c-13 -20 -13 -29 1 -78 11 -38 16 -96 16 -185 0 -117 -5
            -153 -49 -360 -47 -225 -48 -234 -48 -405 0 -198 12 -255 56 -280 24 -13 29
            -13 48 5 23 21 23 28 0 140 -21 101 -7 261 45 515 65 322 70 520 17 630 -22
            44 -63 53 -86 18z"/>
            <path d="M417 4559 c-66 -50 -106 -198 -86 -320 14 -85 38 -137 83 -176 l37
            -33 644 0 c572 0 645 2 659 16 19 18 21 55 4 72 -9 9 -152 12 -581 12 l-568 0
            7 23 c17 52 24 96 24 152 0 56 -7 100 -24 153 l-7 22 528 0 c398 0 532 3 541
            12 7 7 12 24 12 38 0 14 -5 31 -12 38 -9 9 -161 12 -623 12 -602 -1 -610 -1
            -638 -21z m114 -177 c19 -95 -9 -242 -48 -242 -24 0 -46 63 -51 146 -5 85 8
            144 37 177 15 18 16 18 33 -3 9 -11 22 -46 29 -78z"/>
            <path d="M3618 4569 c-21 -12 -24 -59 -6 -77 9 -9 138 -12 518 -12 568 0 524
            6 550 -74 18 -57 9 -194 -16 -237 l-20 -34 -494 -5 -495 -5 -10 -29 c-8 -24
            -6 -31 14 -47 22 -18 47 -19 510 -19 562 0 535 -4 584 92 72 139 44 371 -53
            436 l-33 22 -516 0 c-332 0 -522 -4 -533 -11z"/>
            <path d="M668 2369 c-11 -6 -18 -22 -18 -39 0 -15 77 -383 171 -817 116 -536
            179 -805 196 -840 39 -83 113 -157 201 -200 l76 -38 1275 0 c1214 0 1278 1
            1324 18 109 43 209 145 251 257 28 76 297 1620 286 1641 -23 42 -84 30 -94
            -18 -3 -16 -67 -372 -141 -793 -75 -421 -143 -785 -152 -810 -25 -66 -114
            -151 -186 -179 l-59 -21 -1241 2 -1242 3 -64 35 c-74 40 -131 106 -155 177 -8
            27 -88 383 -176 793 -89 410 -165 762 -171 782 -13 50 -45 68 -81 47z"/>
            <path d="M1835 1915 c-33 -7 -80 -22 -105 -33 -128 -54 -316 -64 -454 -22 -88
            27 -109 22 -114 -26 -4 -41 182 -823 208 -874 44 -85 134 -150 239 -170 73
            -14 1839 -14 1912 0 113 22 201 88 245 185 29 63 165 824 154 864 -11 42 -31
            47 -111 23 -144 -42 -298 -38 -427 9 -131 49 -210 61 -342 56 -115 -4 -135 -8
            -250 -47 -121 -42 -129 -44 -250 -44 -122 0 -128 1 -250 44 -120 41 -130 43
            -260 46 -90 2 -155 -1 -195 -11z m405 -128 c58 -20 132 -41 164 -46 133 -24
            307 -6 426 44 138 58 315 58 483 1 166 -57 285 -69 424 -45 35 6 66 9 69 7 10
            -10 -117 -701 -135 -736 -25 -48 -66 -87 -113 -106 -33 -14 -152 -16 -993 -16
            -788 0 -961 2 -989 14 -48 20 -100 70 -119 113 -19 43 -180 723 -173 730 2 2
            30 0 62 -6 124 -23 262 -9 405 40 122 42 161 49 279 45 89 -3 121 -9 210 -39z"/>
            <path d="M1783 1510 c-34 -14 -41 -59 -13 -82 18 -14 40 -18 109 -18 97 0 131
            14 131 55 0 40 -35 55 -125 54 -44 0 -90 -4 -102 -9z"/>
            <path d="M2857 1392 c-21 -23 -22 -46 -1 -66 12 -13 38 -16 118 -16 111 0 126
            6 126 52 0 39 -25 48 -133 48 -78 0 -97 -3 -110 -18z"/>
            <path d="M2226 1178 c-20 -29 -20 -34 4 -58 17 -17 33 -20 113 -20 94 0 118 8
            130 41 3 9 -1 26 -9 38 -14 19 -25 21 -119 21 -96 0 -105 -2 -119 -22z"/>
        </g>`,
        200: `<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="#196919" stroke="none">
            <path d="M713 5089 c-48 -23 -89 -67 -110 -116 -9 -23 -13 -82 -13 -200 l0
            -168 -51 -28 c-27 -16 -78 -55 -112 -87 l-63 -58 -79 19 c-66 16 -88 17 -127
            8 -88 -20 -137 -99 -155 -248 -4 -39 -1 -59 16 -95 28 -56 71 -84 169 -107 41
            -10 75 -19 76 -21 2 -2 13 -32 26 -68 44 -126 126 -226 240 -295 l60 -36 0
            -223 0 -223 -45 -1 c-55 -1 -97 -22 -128 -64 -13 -18 -56 -103 -96 -188 -80
            -176 -87 -216 -48 -285 19 -35 37 -48 144 -100 l123 -60 0 -428 c0 -282 4
            -435 11 -448 25 -48 105 -44 128 7 7 17 11 145 11 409 0 212 2 385 5 385 2 0
            59 -25 125 -56 l120 -57 0 -1048 0 -1049 -125 0 -125 0 0 560 0 561 -25 24
            c-30 30 -64 32 -99 4 l-26 -20 0 -596 c0 -533 2 -598 16 -623 33 -55 55 -60
            256 -60 197 0 216 4 252 53 18 25 21 45 24 163 l4 134 543 0 c378 0 552 3 568
            11 24 11 47 47 47 73 0 7 -9 25 -21 40 l-20 26 -560 0 -559 0 0 80 0 80 881
            -2 880 -3 30 -75 c16 -41 29 -76 29 -77 0 -2 -95 -3 -210 -3 -197 0 -211 -1
            -230 -20 -27 -27 -26 -81 1 -106 19 -17 43 -19 261 -24 l240 -5 52 -135 c87
            -224 65 -210 332 -210 l196 0 33 33 c64 64 68 47 -155 628 -111 288 -204 530
            -207 537 -3 7 2 12 11 12 29 0 94 38 114 67 10 16 51 98 91 183 51 113 71 167
            71 197 l0 41 68 7 c417 43 816 241 1091 542 502 549 593 1352 225 1998 -87
            152 -206 300 -250 311 -38 10 -78 -24 -82 -67 -3 -29 7 -47 67 -122 70 -86
            163 -235 196 -312 74 -171 109 -295 130 -452 89 -667 -260 -1310 -870 -1603
            -193 -93 -378 -138 -595 -147 l-135 -6 -285 133 c-157 73 -332 154 -390 181
            l-104 50 62 62 62 62 27 -18 c46 -29 178 -95 235 -117 248 -96 580 -106 838
            -24 469 148 811 549 887 1038 18 120 13 321 -12 436 -108 513 -492 896 -1008
            1007 -61 13 -126 18 -252 18 -177 0 -225 -7 -374 -51 -389 -117 -709 -429
            -840 -820 -87 -260 -85 -574 5 -826 30 -84 100 -225 138 -282 15 -21 26 -42
            24 -47 -2 -4 -43 -49 -93 -99 l-89 -92 -23 29 c-44 54 -131 208 -173 306 -87
            206 -127 430 -117 671 17 403 167 747 452 1031 235 236 515 381 840 437 156
            27 429 21 570 -11 198 -46 377 -121 535 -225 47 -31 92 -56 100 -56 23 0 60
            29 70 56 16 42 -5 71 -92 128 -484 314 -1092 363 -1621 130 -156 -68 -342
            -190 -457 -299 l-45 -43 -488 -95 -488 -94 -57 56 c-32 31 -78 67 -104 81
            l-46 24 -4 181 c-3 195 -7 211 -65 269 -65 66 -178 86 -260 45z m156 -155 c19
            -24 21 -40 21 -158 l0 -131 -75 0 -75 0 0 138 c0 124 2 139 20 157 30 30 83
            27 109 -6z m2471 -699 c0 -267 -2 -305 -15 -305 -28 0 -136 -40 -177 -67 l-41
            -25 -208 213 c-114 118 -208 217 -208 222 -2 15 124 99 220 147 128 64 296
            112 412 119 16 1 17 -20 17 -304z m266 290 c172 -30 342 -101 476 -198 32 -23
            58 -46 58 -51 0 -4 -92 -104 -205 -221 l-205 -213 -68 34 c-37 19 -91 40 -119
            47 l-53 12 0 302 c0 250 2 303 14 303 7 0 53 -7 102 -15z m-2654 -55 c176 -66
            285 -264 248 -445 -42 -204 -212 -335 -419 -323 -141 8 -269 95 -333 226 -78
            157 -32 364 105 475 116 94 262 119 399 67z m1043 -129 c-118 -179 -200 -379
            -247 -597 -20 -95 -23 -137 -23 -326 0 -156 -3 -214 -11 -210 -6 4 -129 114
            -274 246 l-262 239 36 35 35 36 73 -17 c94 -22 122 -22 175 4 55 27 86 79 106
            180 32 156 -20 226 -190 259 -61 12 -62 13 -77 56 -8 24 -14 44 -13 45 2 1
            714 145 729 148 4 0 -22 -44 -57 -98z m-1740 -37 c31 -5 36 -10 31 -28 -3 -12
            -10 -45 -16 -74 -7 -28 -17 -52 -23 -52 -24 0 -86 21 -93 31 -7 12 15 109 29
            127 6 7 16 11 23 8 7 -3 29 -8 49 -12z m2723 -599 c-29 -44 -60 -114 -73 -165
            l-11 -45 -302 -3 -302 -2 0 27 c0 50 37 206 70 295 35 96 104 219 172 304 l43
            54 212 -218 211 -217 -20 -30z m1379 333 c93 -141 159 -307 178 -454 3 -27 8
            -59 11 -71 l4 -23 -303 0 -304 0 -18 65 c-9 36 -32 90 -51 121 -19 31 -34 58
            -34 61 0 3 93 101 207 219 240 248 205 239 310 82z m-2937 -3 c46 -13 49 -21
            35 -81 -17 -74 -23 -79 -82 -65 l-49 12 14 62 c8 34 17 68 18 75 2 7 12 11 21
            8 10 -2 29 -8 43 -11z m2167 -290 c110 -55 178 -146 203 -273 21 -104 -15
            -230 -90 -316 -65 -73 -183 -126 -283 -126 l-50 0 66 69 c74 77 106 136 107
            196 0 69 -19 115 -69 165 -61 60 -125 79 -209 60 -48 -11 -65 -22 -140 -94
            l-85 -81 5 80 c16 279 295 443 545 320z m-2172 -470 l360 -326 30 -87 c16 -48
            59 -147 95 -219 37 -73 64 -133 61 -133 -3 0 -212 95 -463 212 l-458 213 0
            333 c0 182 3 332 8 332 4 0 169 -146 367 -325z m-525 4 c0 -149 -4 -269 -8
            -267 -4 2 -38 16 -75 33 l-67 29 0 238 0 238 75 0 75 0 0 -271z m2475 76 c16
            -15 25 -36 25 -55 0 -27 -40 -72 -327 -368 -180 -185 -396 -407 -480 -492
            l-152 -155 -71 35 -72 36 412 424 c568 587 582 600 614 600 15 0 38 -11 51
            -25z m-469 -42 c3 -16 10 -41 15 -57 11 -36 14 -32 -237 -288 l-193 -198 -40
            68 c-74 124 -135 304 -148 435 l-6 67 301 0 302 0 6 -27z m1647 20 c8 -13 -21
            -184 -43 -258 -33 -107 -102 -242 -168 -332 -33 -44 -64 -83 -69 -86 -8 -5
            -423 414 -423 427 0 3 14 27 30 53 17 26 40 80 52 118 11 39 23 73 25 78 2 4
            136 7 298 7 162 0 296 -3 298 -7z m-2581 -992 c829 -387 1394 -656 1396 -665
            5 -22 -129 -306 -144 -306 -12 0 -176 75 -954 438 -113 52 -218 95 -234 95
            -52 0 -86 -72 -53 -116 6 -9 129 -71 272 -138 143 -66 264 -124 269 -129 7 -7
            275 -684 276 -697 0 -2 -81 -3 -180 -3 l-180 0 0 79 c0 90 -10 124 -48 165
            -52 55 -60 56 -452 56 -334 0 -364 -1 -398 -19 -74 -38 -102 -94 -102 -206 l0
            -75 -170 0 -170 0 0 684 0 684 298 -139 c163 -77 310 -141 326 -141 20 -1 37
            7 53 26 29 34 29 58 1 90 -15 16 -266 138 -688 334 -365 170 -669 316 -674
            324 -14 22 121 308 145 308 10 0 645 -292 1411 -649z m2160 181 c-50 -42 -185
            -121 -261 -153 -84 -35 -227 -73 -313 -84 l-58 -6 0 303 0 304 58 12 c31 7 84
            28 117 46 l60 34 212 -217 212 -216 -27 -23z m-782 60 l0 -304 -52 7 c-145 18
            -294 66 -416 133 l-64 35 49 51 c26 28 126 130 221 227 l173 175 44 -10 45
            -11 0 -303z m-97 -1839 c114 -296 210 -548 213 -561 l6 -23 -128 3 -128 3
            -243 625 c-133 344 -243 628 -243 632 0 4 71 -27 158 -68 l157 -74 208 -537z
            m-965 150 l3 -73 -351 0 -350 0 0 68 c0 38 3 72 7 75 4 4 160 6 347 5 l341 -3
            3 -72z"/>
            <path d="M710 4324 c-156 -67 -196 -278 -76 -398 100 -100 254 -98 353 6 44
            45 63 96 63 166 0 100 -44 173 -131 217 -57 29 -153 33 -209 9z m165 -159 c51
            -50 21 -147 -49 -161 -68 -12 -126 48 -111 115 15 68 111 96 160 46z"/>
        </g>`,
        300: `<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="#856B3E" stroke="none">
            <path d="M178 5104 c-34 -18 -37 -32 -41 -159 l-2 -100 -49 -6 c-85 -9 -86
            -14 -86 -276 l0 -225 29 -29 c23 -23 39 -29 70 -29 l41 0 0 -1720 0 -1720 -41
            0 c-31 0 -47 -6 -70 -29 l-29 -29 0 -225 c0 -262 1 -267 86 -276 l49 -6 3
            -105 c2 -114 11 -142 49 -159 16 -7 140 -11 379 -11 l356 0 29 29 c29 29 29
            31 29 140 l0 111 270 0 270 0 0 -45 c0 -35 6 -52 25 -70 l24 -25 991 0 991 0
            24 25 c19 18 25 35 25 70 l0 45 270 0 270 0 0 -111 c0 -109 0 -111 29 -140
            l29 -29 356 0 c239 0 363 4 379 11 38 17 47 45 49 159 l3 105 49 6 c85 9 86
            14 86 276 l0 225 -29 29 c-23 23 -39 29 -70 29 l-41 0 0 1305 c0 1292 0 1305
            -20 1325 -30 30 -83 27 -109 -6 l-21 -27 0 -1298 0 -1299 -270 0 -270 0 0 819
            0 819 185 4 c174 3 186 4 206 25 27 27 29 75 4 103 -16 18 -33 20 -204 22
            l-186 3 -3 183 c-1 100 1 182 5 182 5 0 79 -22 165 -50 137 -43 161 -48 189
            -38 48 16 59 55 59 205 0 102 -4 135 -18 163 -19 38 -22 39 -262 114 l-135 42
            -3 422 -2 422 270 0 270 0 0 -264 c0 -263 0 -265 23 -292 31 -35 82 -38 109
            -5 16 21 18 46 18 292 l0 269 41 0 c31 0 47 6 70 29 l29 29 0 225 c0 262 -1
            267 -86 276 l-49 6 -3 105 c-2 114 -11 142 -49 159 -16 7 -140 11 -379 11
            l-356 0 -29 -29 c-29 -29 -29 -31 -29 -140 l0 -111 -270 0 -270 0 0 41 c0 31
            -6 47 -29 70 l-29 29 -982 0 -982 0 -29 -29 c-23 -23 -29 -39 -29 -70 l0 -41
            -270 0 -270 0 0 111 c0 109 0 111 -29 140 l-29 29 -359 0 c-297 -1 -363 -3
            -385 -16z m652 -199 l0 -65 -270 0 -270 0 0 65 0 65 270 0 270 0 0 -65z m4000
            0 l0 -65 -267 2 -268 3 -3 63 -3 62 271 0 270 0 0 -65z m-2900 -219 c0 -130 2
            -146 21 -170 26 -33 79 -36 109 -6 18 18 20 33 20 170 l0 150 65 0 65 0 0
            -1030 0 -1031 -62 3 -63 3 -5 737 c-5 804 -2 759 -62 773 -22 6 -33 1 -58 -23
            l-30 -30 0 -731 0 -731 -43 0 c-56 0 -84 -29 -93 -93 l-7 -47 -58 0 -59 0 0
            1100 0 1100 130 0 130 0 0 -144z m830 -886 l0 -1030 -200 0 -200 0 0 1030 0
            1030 200 0 200 0 0 -1030z m278 3 l-3 -1028 -62 -3 -63 -3 0 1031 0 1030 65 0
            65 0 -2 -1027z m412 -73 l0 -1100 -59 0 -58 0 -7 47 c-9 64 -37 93 -93 93
            l-43 0 0 1030 0 1030 130 0 130 0 0 -1100z m-3145 896 l106 -64 -109 -66 c-61
            -36 -119 -66 -131 -66 -20 0 -21 4 -21 130 l0 130 24 0 c14 0 73 -29 131 -64z
            m287 44 l-34 -21 -31 20 -32 21 65 0 65 0 -33 -20z m928 -110 l0 -130 -297 0
            -297 0 -103 61 c-57 34 -105 64 -107 68 -3 4 41 35 97 69 l102 61 303 1 302 0
            0 -130z m2785 68 c57 -34 102 -65 99 -69 -2 -4 -50 -34 -107 -68 l-103 -61
            -297 0 -297 0 0 130 0 130 301 0 301 0 103 -62z m288 41 l-31 -20 -34 21 -33
            20 65 0 65 0 -32 -21z m377 -109 c0 -126 -1 -130 -21 -130 -12 0 -70 30 -131
            66 l-110 66 104 63 c57 35 115 64 131 64 l27 1 0 -130z m-4380 -105 c17 -9 30
            -18 30 -20 0 -3 -30 -5 -67 -5 l-68 0 30 19 c37 24 39 24 75 6z m4012 -5 l33
            -20 -67 0 c-38 0 -68 2 -68 5 0 5 52 34 62 35 4 0 22 -9 40 -20z m-3774 -592
            l-3 -421 -190 -61 c-234 -75 -225 -65 -225 -259 0 -150 11 -189 59 -205 28
            -10 52 -5 189 38 86 28 160 50 165 50 4 0 6 -82 5 -182 l-3 -183 -186 -3
            c-171 -2 -188 -4 -204 -22 -25 -28 -23 -76 4 -103 20 -21 32 -22 206 -25 l185
            -4 0 -819 0 -819 -270 0 -270 0 0 1720 0 1720 270 0 270 0 -2 -422z m647 380
            c-6 -45 -55 -634 -55 -654 0 -6 -39 -19 -87 -28 -49 -10 -145 -31 -214 -47
            -70 -16 -129 -29 -133 -29 -3 0 -6 180 -6 400 l0 400 250 0 250 0 -5 -42z
            m2665 -358 c0 -220 -3 -400 -6 -400 -4 0 -72 15 -153 34 -80 19 -176 39 -213
            46 -38 7 -68 17 -68 24 0 20 -49 608 -55 654 l-5 42 250 0 250 0 0 -400z
            m-2620 -503 l0 -63 -152 -28 c-194 -36 -472 -105 -655 -162 -78 -24 -145 -44
            -148 -44 -3 0 -5 25 -5 55 0 43 4 56 19 64 30 16 332 106 476 141 105 26 427
            96 458 99 4 1 7 -27 7 -62z m2280 22 c239 -47 679 -166 742 -200 14 -8 18 -22
            18 -64 0 -30 -2 -55 -3 -55 -2 0 -71 21 -153 46 -189 58 -457 123 -652 160
            l-152 28 0 63 c0 61 1 63 23 58 12 -2 92 -19 177 -36z m-2434 -466 c-9 -109
            -19 -222 -22 -250 l-6 -53 -179 0 -179 0 0 208 0 208 158 37 c220 50 237 54
            241 51 2 -2 -4 -92 -13 -201z m2662 140 l112 -27 0 -208 0 -208 -180 0 c-99 0
            -180 3 -180 8 0 4 -9 108 -20 232 -11 124 -20 235 -20 247 l0 21 88 -19 c48
            -10 138 -31 200 -46z m-2513 -432 c-3 -8 -9 -11 -14 -5 -5 5 -4 67 2 144 l12
            135 3 -129 c1 -72 0 -137 -3 -145z m2108 -4 c-16 -25 -23 21 -22 141 l2 137
            12 -135 c7 -74 11 -138 8 -143z m-443 -77 l0 -60 -620 0 -620 0 0 60 0 60 620
            0 620 0 0 -60z m-1856 -127 c-26 -238 -80 -981 -74 -999 17 -44 47 -54 162
            -54 l108 0 0 -270 0 -270 -87 0 c-75 0 -90 -3 -110 -22 -33 -30 -31 -80 3
            -107 22 -17 41 -21 110 -21 l84 0 0 -130 0 -130 -301 0 -301 0 -103 62 c-57
            34 -102 65 -99 69 2 4 50 34 107 68 93 55 109 61 159 61 72 0 87 6 103 43 24
            58 -10 107 -74 107 l-31 0 0 820 0 820 175 0 174 0 -5 -47z m196 -428 l0 -475
            -60 0 c-33 0 -60 3 -60 7 0 20 71 865 76 901 4 33 9 42 25 42 19 0 19 -12 19
            -475z m274 433 c10 -60 39 -88 93 -88 l43 0 0 -1030 0 -1030 -130 0 -130 0 0
            1095 0 1095 59 0 58 0 7 -42z m1656 -1053 l0 -1095 -130 0 -130 0 0 1030 0
            1030 43 0 c54 0 83 28 93 88 l7 42 58 0 59 0 0 -1095z m194 1053 c5 -36 76
            -881 76 -901 0 -4 -27 -7 -60 -7 l-60 0 0 475 c0 463 0 475 19 475 16 0 21 -9
            25 -42z m496 -778 l0 -820 -270 0 -270 0 0 270 0 270 108 0 c115 0 145 10 162
            54 6 18 -48 761 -74 999 l-5 47 174 0 175 0 0 -820z m-1930 -340 l0 -1030 -65
            0 -65 0 0 1023 c0 563 3 1027 7 1030 3 4 33 7 65 7 l58 0 0 -1030z m550 0 l0
            -1030 -200 0 -200 0 0 1030 0 1030 200 0 200 0 0 -1030z m278 -2 l2 -1028 -65
            0 -65 0 0 1030 0 1031 63 -3 62 -3 3 -1027z m-2736 -694 l109 -66 -106 -64
            c-58 -35 -117 -64 -131 -64 l-24 0 0 130 c0 126 1 130 21 130 12 0 70 -30 131
            -66z m314 57 c-3 -4 -19 -14 -34 -20 -25 -11 -34 -9 -63 8 l-34 21 68 0 c38 0
            66 -4 63 -9z m3681 -52 c57 -34 105 -64 107 -68 3 -4 -42 -35 -99 -69 l-103
            -62 -301 0 -301 0 0 130 0 130 297 0 297 0 103 -61z m304 40 c-29 -17 -38 -19
            -63 -8 -50 20 -41 29 29 29 l68 0 -34 -21z m369 -109 l0 -130 -24 0 c-14 0
            -73 29 -131 64 l-106 64 108 66 c59 36 118 65 131 66 22 0 22 -2 22 -130z
            m-4378 -110 l33 -20 -65 0 -65 0 30 20 c36 24 28 24 67 0z m4003 0 l30 -20
            -65 0 -65 0 30 19 c38 25 34 25 70 1z m-3765 -235 l0 -65 -270 0 -270 0 0 65
            0 65 270 0 270 0 0 -65z m4000 0 l0 -65 -270 0 -270 0 0 58 c0 32 3 62 7 65 3
            4 125 7 270 7 l263 0 0 -65z"/>
        </g>`
    };
    BASE_ICON = { w: 86, h: 100, anchorY: 76 };
    constructor($el,options={}) {
        this.$el = $el;
        this.options = options;
        this.init()
    }
    #getPCodeGroup(pCode) {
        const n = parseInt(pCode, 10);
        if (!Number.isFinite(n)) return null;
        return String(Math.floor(n / 100) * 100);
    }
    init(){
        this.map = L.map(this.options.container_id, {
            maxZoom:this.options.maxZoom
        }).setView(
            [this.options.center.latitude, this.options.center.longitude],
            this.options.zoom,
        );
        L.tileLayer('https://tile.openstreetmap.de/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            noWrap: false
        }).addTo(this.map);

        this.map.on('zoomend', () => this.updateIconSizes());
    }

    getScaleForZoom(zoom){
        const minZ = 2, maxZ = 10;
        const minS = 0.5, maxS = 1.6;
        const z = Math.min(maxZ, Math.max(minZ, zoom));
        const t = (z - minZ) / (maxZ - minZ);
        return minS + t * (maxS - minS);
    }

    getIcon(type = null, scale = 1) {
        let color = this.default_color;
        if (this.stop_colors && type && this.stop_colors[type]) {
            color = this.stop_colors[type];
        }
        const iconSvg = this.typeIcons[type] || '';

        const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="66" viewBox="0 0 57 66">
      <defs>
        <filter id="Icon_awesome-map-marker-alt" x="0" y="0" width="57" height="66" filterUnits="userSpaceOnUse">
          <feOffset input="SourceAlpha"/>
          <feGaussianBlur stdDeviation="5" result="blur"/>
          <feFlood flood-opacity="0.102"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>


      <g filter="url(#Icon_awesome-map-marker-alt)">
        <path d="M12.113,35.274C1.9,20.463,0,18.943,0,13.5a13.5,13.5,0,0,1,27,0c0,5.443-1.9,6.963-12.113,21.774a1.688,1.688,0,0,1-2.775,0ZM13.5,19.125A5.625,5.625,0,1,0,7.875,13.5,5.625,5.625,0,0,0,13.5,19.125Z"
              transform="translate(15 15)" fill="${color}"/>
      </g>

      ${iconSvg ? `
  <g transform="translate(6,6)">
    <circle cx="12" cy="12" r="10" fill="white" stroke="${color}" stroke-width="2"/>

    <g transform="translate(12,12)">
      <g transform="translate(-7,-7) scale(${14/512})">
        ${iconSvg}
      </g>
    </g>
  </g>
` : ''}
    </svg>
    `.trim();

        const svgUrl = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);

        const W = this.BASE_ICON.w * scale;
        const H = this.BASE_ICON.h * scale;
        const anchorX = W / 2;
        const anchorY = this.BASE_ICON.anchorY * scale;

        return L.icon({
            iconUrl: svgUrl,
            iconRetinaUrl: svgUrl,
            iconSize: [W, H],
            iconAnchor: [anchorX, anchorY],
            popupAnchor: [0, -anchorY]
        });
    }

    addMarker(lat, lng, label = "", key = null, type = null){
        const scale = this.getScaleForZoom(this.map.getZoom());
        const marker = L.marker([lat, lng], { icon: this.getIcon(type, scale) }).addTo(this.map);

        const clean = (label && label.trim()) ? label.trim() : null;
        if (clean) marker.bindPopup(clean);
        if (key != null) {
            this.markersByKey[key] = { lat, lng, marker, type };
        }
        return marker;
    }



    updateIconSizes(){
        const scale = this.getScaleForZoom(this.map.getZoom());
        for (const key in this.markersByKey){
            const entry = this.markersByKey[key];
            if (!entry?.marker) continue;
            entry.marker.setIcon(this.getIcon(entry.type, scale));
        }
    }

    #isBlank(v){
        return v == null || (typeof v === 'string' && v.trim().length === 0);
    }

    #offsetMeters(lat, lng, dxMeters, dyMeters){
        const R = 6378137;
        const dLat = (dyMeters / R) * (180 / Math.PI);
        const dLng = (dxMeters / (R * Math.cos(lat * Math.PI/180))) * (180 / Math.PI);
        return [lat + dLat, lng + dLng];
    }

    #circlePositions(centerLat, centerLng, count, radiusMeters){
        const out = [];
        const start = -Math.PI/2;
        for (let i=0; i<count; i++){
            const a = start + i * (2*Math.PI / count);
            const dx = Math.cos(a) * radiusMeters;
            const dy = Math.sin(a) * radiusMeters;
            out.push(this.#offsetMeters(centerLat, centerLng, dx, dy));
        }
        return out;
    }

    /**
     * Platziert Locations pro Land.
     * items: [{ pCode, pCodeBez, label, latitude, longitude, ... }]
     * Marker-Key: pCode
     * - Items ohne Koordinaten: um Landeszentrum im Kreis
     * - Items mit gleicher Koordinate: um diese Koordinate im kleinen Kreis
     */
    addCountryLocations(country, items, opts = {}) {
        const centerLat = country.lat;
        const centerLng = country.lng;

        const radius = Number.isFinite(opts.radius) ? opts.radius : 15000;
        const localRadius = Number.isFinite(opts.localRadius) ? opts.localRadius : 8000;

        const popupFormatter = typeof opts.popupFormatter === "function"
            ? opts.popupFormatter
            : (it) => {
                const lbl = this.#isBlank(it.label) ? null : it.label.trim();
                return lbl || it.pCodeBez || "";
            };

        if (!this.markersByKey) this.markersByKey = {};

        const byId = new Map();
        for (const it of (items || [])) {
            const key = (it.id ?? "").toString();
            if (!key) continue;
            if (!byId.has(key)) byId.set(key, it);
        }
        const list = Array.from(byId.values());
        if (!list.length) return;

        const noCoord = [];
        const coordGroups = new Map();

        for (const item of list) {
            let lat = parseFloat(item.latitude);
            let lng = parseFloat(item.longitude);

            if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                noCoord.push(item);
                continue;
            }

            const key = `${lat.toFixed(6)}|${lng.toFixed(6)}`;
            if (!coordGroups.has(key)) {
                coordGroups.set(key, { lat, lng, items: [] });
            }
            coordGroups.get(key).items.push(item);
        }

        if (noCoord.length === 1) {
            const item = noCoord[0];
            const pop = popupFormatter(item);
            const idKey = item.id
            const group = this.#getPCodeGroup(item.pCode);
            this.addMarker(centerLat, centerLng, pop, idKey, group);
        }
        // else if (noCoord.length > 1) {
        //     const fallbackPos = this.#circlePositions(centerLat, centerLng, noCoord.length, radius);
        //     noCoord.forEach((item, idx) => {
        //         const [lat, lng] = fallbackPos[idx];
        //         const pop = popupFormatter(item);
        //         const idKey = item.pCode.toString();
        //         this.addMarker(lat, lng, pop, idKey, item.pCodeBez);
        //     });
        // }

        for (const group of coordGroups.values()) {
            const { lat, lng, items: gItems } = group;

            if (gItems.length === 1) {
                const item = gItems[0];
                const pop = popupFormatter(item);
                const idKey = item.id
                const group = this.#getPCodeGroup(item.pCode);
                this.addMarker(lat, lng, pop, idKey, group);
                continue;
            }

            const circlePos = this.#circlePositions(lat, lng, gItems.length, localRadius);
            gItems.forEach((item, idx) => {
                const [clat, clng] = circlePos[idx];
                const pop = popupFormatter(item);
                const idKey = item.id;
                const group = this.#getPCodeGroup(item.pCode);
                this.addMarker(clat, clng, pop, idKey, group);
            });
        }
    }

    addConnectionById(fromId, toId, options = {}) {
        const from = this.markersByKey[fromId];
        const to   = this.markersByKey[toId];
        if (!from || !to) return null;
        return this.#drawHybridRoute(from, to, options);
    }

    #lonDeltaShort(fromLon, toLon){
        const raw = toLon - fromLon;
        return ((raw + 540) % 360) - 180;
    }

    #lonDeltaLong(fromLon, toLon){
        const dShort = this.#lonDeltaShort(fromLon, toLon);
        return dShort > 0 ? dShort - 360 : dShort + 360;
    }

    #crossesDateline(points){
        if (!points || points.length < 2) return false;
        for (let i = 1; i < points.length; i++){
            const prev = this.#wrapLon(points[i-1][1]);
            const curr = this.#wrapLon(points[i][1]);
            if (Math.abs(curr - prev) > 180) return true;
        }
        return false;
    }

    #drawHybridRoute(from, to, options = {}) {
        const steps = options.steps ?? 128;
        const preferAtlantic = options.preferAtlantic ?? true;

        const shortPts = this.#greatCirclePoints(
            from.lat, from.lng,
            to.lat,   to.lng,
            steps,
            { arcBias: 0 }
        );

        const wouldCrossPacific = this.#crossesDateline(shortPts);

        if (preferAtlantic && wouldCrossPacific) {
            return this.#drawFlatRoute(from, to, {
                ...options,
                forceLongWay: true
            });
        }

        return this.#drawGreatCircleSplit(from, to, options);
    }
    #clamp(v, min, max){
        return Math.min(max, Math.max(min, v));
    }
    #wrapLon(lon){
        return ((lon + 540) % 360) - 180;
    }

    #lonDeltaShortest(fromLon, toLon){
        let d = toLon - fromLon;
        if (d > 180) d -= 360;
        if (d < -180) d += 360;
        return d;
    }

    #chooseLonDelta(fromLon, toLon, preferAtlantic = true){
        const dShort = this.#lonDeltaShortest(fromLon, toLon);
        if (!preferAtlantic) return dShort;

        if (Math.abs(dShort) <= 180) return dShort;

        const dLong = dShort > 0 ? dShort - 360 : dShort + 360;
        return dLong;
    }

    #bezier(points, steps){
        const out = [];
        const [p0, p1, p2, p3] = points;
        for (let i = 0; i <= steps; i++){
            const t = i / steps;
            const mt = 1 - t;
            const mt2 = mt * mt;
            const t2 = t * t;

            const lat =
                mt2 * mt * p0[0] +
                3 * mt2 * t * p1[0] +
                3 * mt * t2 * p2[0] +
                t2 * t * p3[0];

            const lon =
                mt2 * mt * p0[1] +
                3 * mt2 * t * p1[1] +
                3 * mt * t2 * p2[1] +
                t2 * t * p3[1];

            out.push([lat, lon]);
        }
        return out;
    }

    #drawFlatRoute(from, to, options = {}) {
        const steps = options.steps ?? 128;
        const forceLongWay = options.forceLongWay ?? false;

        const dLon = forceLongWay
            ? this.#lonDeltaLong(from.lng, to.lng)
            : this.#lonDeltaShort(from.lng, to.lng);

        const endLonUnwrapped = from.lng + dLon;

        const midLat = (from.lat + to.lat) / 2;

        const flatness = Number.isFinite(options.flatness) ? options.flatness : 0.85;

        const ctrlLon1 = from.lng + dLon * 0.33;
        const ctrlLon2 = from.lng + dLon * 0.66;

        const ctrlLat1 = from.lat + (midLat - from.lat) * flatness;
        const ctrlLat2 = to.lat   + (midLat - to.lat)   * flatness;

        const p0 = [from.lat, from.lng];
        const p1 = [ctrlLat1, ctrlLon1];
        const p2 = [ctrlLat2, ctrlLon2];
        const p3 = [to.lat,   endLonUnwrapped];

        const ptsUnwrapped = this.#bezier([p0, p1, p2, p3], steps);
        const ptsWrapped = ptsUnwrapped.map(([la, lo]) => [la, this.#wrapLon(lo)]);

        return [L.polyline(ptsWrapped, {
            weight: options.weight ?? 2,
            opacity: options.opacity ?? 0.7,
            color: options.color ?? '#b10023',
            lineCap: 'round',
            lineJoin: 'round'
        }).addTo(this.map)];
    }
    #haversineKm(lat1, lon1, lat2, lon2){
        const R = 6371;
        const dLat = this.#toRad(lat2 - lat1);
        const dLon = this.#toRad(lon2 - lon1);
        const a =
            Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(this.#toRad(lat1)) * Math.cos(this.#toRad(lat2)) *
            Math.sin(dLon/2) * Math.sin(dLon/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    #getArcBiasByDistanceKm(distanceKm, factor = 1){
        const minKm = 2500;
        const maxKm = 14000;

        const t = this.#clamp((distanceKm - minKm) / (maxKm - minKm), 0, 1);

        const easeOut = 1 - Math.pow(1 - t, 2);

        const minBias = 0.55;
        const maxBias = 0.80;

        const bias = minBias + (maxBias - minBias) * easeOut;

        return this.#clamp(bias * factor, 0.35, 0.95);
    }
    #drawGreatCircleSplit(from, to, options = {}) {
        const steps = options.steps ?? 128;

        const dLon = Math.abs(to.lng - from.lng);
        const preferAtlantic = options.preferAtlantic ?? true;
        const useLongArc = preferAtlantic && dLon > 180;

        const distanceKm = this.#haversineKm(from.lat, from.lng, to.lat, to.lng);

        const arcFactor = Number.isFinite(options.arcFactor) ? options.arcFactor : 1;
        const bendFactorOpt = Number.isFinite(options.bendFactor) ? options.bendFactor : 1;

        const arcBias = useLongArc ? this.#getArcBiasByDistanceKm(distanceKm, arcFactor) : 0;
        const bendFactor = this.#getBendFactorByDistanceKm(distanceKm, bendFactorOpt);

        const pts = this.#greatCirclePoints(
            from.lat, from.lng,
            to.lat,   to.lng,
            steps,
            { arcBias, bendFactor }
        );

        if (useLongArc) {
            return [L.polyline(pts.map(([la, lo]) => [la, lo]), {
                weight: options.weight ?? 2,
                opacity: options.opacity ?? 0.7,
                color: options.color ?? '#b10023',
                lineCap: 'round',
                lineJoin: 'round'
            }).addTo(this.map)];
        }

        const unwrapped = this.#unwrapLongitudes(pts);
        const segments = this.#splitAtDateline(unwrapped);
        const wrap = lon => ((lon + 540) % 360) - 180;

        const lines = [];
        for (const seg of segments) {
            if (seg.length < 2) continue;

            const latlngs = seg.map(([la, lo]) => [la, wrap(lo)]);
            const splitted = this.splitAtJump(latlngs);

            if (splitted.length > 1) {
                for (const split of splitted) {
                    lines.push(L.polyline(split, {
                        weight: options.weight ?? 2,
                        opacity: options.opacity ?? 0.7,
                        color: options.color ?? '#b10023',
                        lineCap: 'round',
                        lineJoin: 'round'
                    }).addTo(this.map));
                }
            } else {
                lines.push(L.polyline(latlngs, {
                    weight: options.weight ?? 2,
                    opacity: options.opacity ?? 0.7,
                    color: options.color ?? '#b10023',
                    lineCap: 'round',
                    lineJoin: 'round'
                }).addTo(this.map));
            }
        }

        return lines;
    }
    #getBendFactorByDistanceKm(distanceKm, factor = 1){
        const minKm = 1500;
        const maxKm = 14000;

        const t = this.#clamp((distanceKm - minKm) / (maxKm - minKm), 0, 1);

        const ease = t * t * (3 - 2 * t);

        const minBend = 0.25;
        const maxBend = 1.00;

        const bend = minBend + (maxBend - minBend) * ease;

        return this.#clamp(bend * factor, 0.1, 1);
    }
    #greatCirclePoints(lat1, lon1, lat2, lon2, steps = 64, opts = {}) {
        const arcBias = Number.isFinite(opts.arcBias) ? opts.arcBias : 0;
        const bendFactor = Number.isFinite(opts.bendFactor) ? opts.bendFactor : 1;

        const o1 = this.#toRad(lat1), u1 = this.#toRad(lon1);
        const o2 = this.#toRad(lat2), u2 = this.#toRad(lon2);

        const v1 = [
            Math.cos(o1) * Math.cos(u1),
            Math.cos(o1) * Math.sin(u1),
            Math.sin(o1)
        ];
        const v2 = [
            Math.cos(o2) * Math.cos(u2),
            Math.cos(o2) * Math.sin(u2),
            Math.sin(o2)
        ];

        const mention = Math.min(1, Math.max(-1, v1[0]*v2[0] + v1[1]*v2[1] + v1[2]*v2[2]));
        const wShort = Math.acos(mention);
        if (wShort === 0) return [[lat1, lon1], [lat2, lon2]];

        const wLong = 2 * Math.PI - wShort;
        const w = wShort + (wLong - wShort) * arcBias;

        const sinw = Math.sin(w);

        const pts = [];
        for (let i = 0; i <= steps; i++) {
            const t = i / steps;

            const A = Math.sin((1 - t) * w) / sinw;
            const B = Math.sin(t * w) / sinw;

            const x = A*v1[0] + B*v2[0];
            const y = A*v1[1] + B*v2[1];
            const z = A*v1[2] + B*v2[2];

            const o = Math.atan2(z, Math.sqrt(x*x + y*y));
            const u = Math.atan2(y, x);

            const gcLat = this.#toDeg(o);
            const gcLon = this.#toDeg(u);

            let linLon = lon1 + (lon2 - lon1) * t;
            let d = lon2 - lon1;
            if (d > 180) d -= 360;
            if (d < -180) d += 360;
            linLon = lon1 + d * t;

            const linLat = lat1 + (lat2 - lat1) * t;

            const outLat = linLat + (gcLat - linLat) * bendFactor;
            const outLon = linLon + (gcLon - linLon) * bendFactor;

            pts.push([outLat, outLon]);
        }

        return pts;
    }

    splitAtJump(points){
        for (let i = 1; i < points.length; i++){
            const lonPrev = points[i-1][1];
            const lonCurr = points[i][1];
            if (Math.abs(lonCurr - lonPrev) > 180){
                const left  = points.slice(0, i);
                const right = points.slice(i);
                return [left, right];
            }
        }
        return [points];
    }

    #unwrapLongitudes(pts) {
        if (!pts || pts.length === 0) return [];
        const out = [ [pts[0][0], pts[0][1]] ];
        for (let i = 1; i < pts.length; i++) {
            const lat = pts[i][0];
            let lon   = pts[i][1];
            const prevLon = out[i-1][1];
            while (lon - prevLon > 180)  lon -= 360;
            while (lon - prevLon < -180) lon += 360;
            out.push([lat, lon]);
        }
        return out;
    }

    #splitAtDateline(pts) {
        if (!pts || pts.length < 2) return [pts.slice()];

        const segments = [];
        let cur = [ pts[0] ];

        const pushCut = (lat1, lon1, lat2, lon2) => {
            const lo = Math.min(lon1, lon2);
            const hi = Math.max(lon1, lon2);
            const cuts = [];
            const startK = Math.floor((lo + 180) / 360);
            const endK   = Math.floor((hi + 180) / 360);
            for (let k = startK; k < endK; k++) cuts.push(-180 + 360*(k+1));

            const out = [];
            let l1 = lon1, a1 = lat1;
            for (const boundary of cuts) {
                const t = (boundary - l1) / (lon2 - l1);
                const latCut = a1 + t * (lat2 - a1);
                out.push([latCut, boundary]);
                l1 = boundary; a1 = latCut;
            }
            return out;
        };

        for (let i = 1; i < pts.length; i++) {
            const [lat1, lon1] = pts[i-1];
            const [lat2, lon2] = pts[i];

            const dLon = Math.abs(lon2 - lon1);

            if (dLon <= 180) {
                cur.push([lat2, lon2]);
                continue;
            }

            const cuts = pushCut(lat1, lon1, lat2, lon2);
            for (const cut of cuts) {
                cur.push(cut);
                segments.push(cur);
                cur = [ cut ];
            }
            cur.push([lat2, lon2]);
        }

        if (cur.length >= 2) segments.push(cur);
        return segments;
    }

    #toRad(d){ return d * Math.PI / 180; }
    #toDeg(r){ return r * 180 / Math.PI; }

    clearMap() {
        if (!this.map) return;

        this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) return;
            this.map.removeLayer(layer);
        });

        this.markersByKey = {};
    }
}











